import React from 'react';

import classes from './AirlineWrapper.scss';

const airlineWrapper = (props) => (
    <div {...props} className={classes.Wrap}>
        {props.children}
    </div>
);

export default airlineWrapper;


// WEBPACK FOOTER //
// ./src/components/Flight/Wrappers/AirlineWrapper/AirlineWrapper.js